import React from 'react';
import './contact.css';
import ContactForm from './ContactForm';
import Navbar from "../components/NavBar";
import '@fortawesome/fontawesome-free/css/all.min.css';
import SEO from "../components/SEO";


const nextSteps = [
    "Schedule a consultation to discuss your training needs",
    "Explore our comprehensive training portfolio",
    "Receive a customized proposal tailored to your organization",
    "Begin your workforce transformation journey"
];

const ContactTransformSection = () => {
    return (
        <>
            <SEO
                title="Contact"
                description="Contact RTS Techsol for technology training, advisory services, talent solutions, and workforce transformation support."
                path="/contact"
            />
            <Navbar />
            <div className="transform-section-container">
                <div className="content-column">
                    <div className="rts-pitch">
                        <h2 className="pitch-heading">Ready to Transform Your Workforce?</h2>
                        <p className="pitch-text"> Partner with RTS TECHSOL to unlock your organization's full potential through cutting-edge technology training solutions by professionals of proactice. Let's discuss how we can accelerate your digital transformation journey. </p>
                    </div>
                    <div className="contact-blocks-container">
                        <div className="contact-block">
                            <div className="icon-container email-icon">
                                <i className="fas fa-envelope"></i>
                            </div>
                            <div className="contact-info">
                                <p className="contact-title">Email Us</p>
                                <p className="contact-detail-text">info@rtstechsol.com</p>
                            </div>
                        </div>

                        <div className="contact-block">
                            <div className="icon-container phone-icon">
                                <i className="fas fa-phone"></i>
                            </div>
                            <div className="contact-info">
                                <p className="contact-title">Call Us</p>
                                <p className="contact-detail-text">+91 6301540477</p>
                                <p className="contact-detail-text">+91 8374787934</p>
                            </div>
                        </div> 

                        <div className="contact-block">
                            <div className="icon-container location-icon">
                                <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <div className="contact-info">
                                <p className="contact-title">Visit Us</p>
                                <p className="contact-detail-text">Vital Rao Nagar, Hitec City, Madhapur, Hyderabad - 500081, India</p>
                            </div>
                        </div>
                    </div>
                    <div className="next-steps-box">
                        <h4 className="next-steps-heading">Next Steps</h4>
                        <ul className="next-steps-list">
                            {nextSteps.map((step, index) => (
                                <li key={index}>{step}</li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="contact-form-column"> <ContactForm /> </div>
            </div>
        </>
    );
};

export default ContactTransformSection;
